import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=d3e84fae&"
import script from "./CustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports